import React, { memo, useMemo } from 'react';
import {
  createLogEntryPayload,
  withTrackProps,
} from '@dpdgroupuk/react-event-tracker';
import { useForm } from 'react-hook-form';

import SimpleModal from '../../components/SimpleModal';
import { PARCEL_SEARCH } from '../../constants/strings';
import { isValidNumber, validateParcelSearch } from './validators';
import ParcelSearchForm from './components/ParcelSearchForm';
import useSearchParcel from '../../hooks/useSearchParcel';
import { PARCEL_SEARCH_MODAL } from '../../constants/analytics';

const ParcelSearch = ({
  open,
  onClose,
  onReset,
  onSearch,
  onFinish,
  onEnter,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      parcelNumber: '',
    },
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });
  const [foundParcels, handleReset, handleSearch] = useSearchParcel();
  const parcelNumber = watch('parcelNumber');

  const handleResetClick = () => {
    handleReset();
    reset();
    onReset();
  };

  const handleSearchClick = (data) => {
    handleSearch(data);
    onSearch();
  };

  const handleFinishClick = () => {
    onFinish();
    onClose();
  };

  const handleEnterParcelNumber = (data) => {
    const validationError = validateParcelSearch(data.parcelNumber);
    if (validationError) {
      setError('parcelNumber', {
        message: validationError,
      });
      return;
    }
    handleSearch(data);
    onEnter(data.parcelNumber);
  };

  const disableSearchButton = useMemo(
    () => isValidNumber(parcelNumber),
    [parcelNumber]
  );

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={PARCEL_SEARCH.toUpperCase()}
      loadId={PARCEL_SEARCH_MODAL.LOAD}
    >
      <form
        onSubmit={handleSubmit(handleEnterParcelNumber)}
        style={{ width: '100%' }}
      >
        <ParcelSearchForm
          handleReset={handleResetClick}
          handleFinish={handleFinishClick}
          handleSearch={handleSubmit(handleSearchClick)}
          control={control}
          foundParcels={foundParcels}
          disableSearchButton={disableSearchButton}
          errors={errors}
          validateParcelNumber={validateParcelSearch}
        />
      </form>
    </SimpleModal>
  );
};

export default withTrackProps({
  onClose: PARCEL_SEARCH_MODAL.CLICK_CLOSE,
  onReset: PARCEL_SEARCH_MODAL.CLICK_RESET,
  onSearch: PARCEL_SEARCH_MODAL.CLICK_SEARCH,
  onFinish: PARCEL_SEARCH_MODAL.CLICK_FINISHED,
  onEnter: (value) =>
    createLogEntryPayload(PARCEL_SEARCH_MODAL.ENTER_PARCEL_NUMBER, { value }),
})(memo(ParcelSearch));
